<template>
	<div class="main-container">
		<ProjectLayout v-if="isProjectPath" />
		<router-view v-if="!isLoginPath && !isLoginPathPreRegist && !isNoticePath && !isProjectPath && !isFieldPath && !isDataDictionaryPath && !isLogPath && !isSettingPath"/>
	</div>
</template>

<script>
import ProjectLayout from "@/components/project/ProjectLayout.vue";

export default {
	name: "App",
	created() {},
	components: {
		ProjectLayout,
	},
	computed: {
		isLoginPath() {
			return this.$route != undefined && this.$route.path.indexOf(this.config.contextRoot + "/login") >= 0
				? true
				: false;
		},
		isLoginPathPreRegist() {
			return this.$route != undefined && this.$route.path.indexOf(this.config.contextRoot + "/preRegistration") >= 0
				? true
				: false;
		},
		isNoticePath() {
			return this.$route != undefined && this.$route.path.indexOf(this.config.contextRoot + "/notice") >= 0
				? true
				: false;
		},
		isProjectPath() {
			return this.$route != undefined
				? true
				: false;
		},
		isFieldPath() {
			return this.$route != undefined && this.$route.path.indexOf(this.config.contextRoot + "/field") >= 0
				? (this.$route.path.indexOf("popup") >= 0 ? false : true)
				: false;
		},
		isLogPath() {
			return this.$route != undefined && this.$route.path.indexOf(this.config.contextRoot + "/system_log") >= 0
				? true
				: false;
		},
		isDataDictionaryPath() {
			return this.$route != undefined && this.$route.path.indexOf(this.config.contextRoot + "/data_dictionary") >= 0
				? true
				: false;
		},
		isSettingPath() {
			return this.$route != undefined && this.$route.path.indexOf(this.config.contextRoot + "/setting") >= 0
				? true
				: false;
		},

	},
};
</script>

<style>
@import "assets/css/common/common.css";
</style>
